import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaEnvelope, FaPhoneVolume, FaFacebookF, FaInstagram,
  FaYoutube, FaLinkedinIn, FaBars, FaTimes, FaArrowRight
} from "react-icons/fa";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.title = "Career - SASPL";
  }, []);

  return (
    <>

      <div className=" ">
        {/* Fixed Header */}
        <div className="w-full fixed top-0 left-0 z-50 backdrop-blur-lg bg-black lg:bg-white/50 shadow-md">
          {/* Top Bar */}
          <div className="hidden sm:flex bg-orange-600 text-white text-sm px-4 md:px-20 py-2 items-center justify-between">
            <div className="flex items-center gap-4">
              <a href="mailto:adminsupport@sasgroups.net" className="flex items-center gap-2">
                <FaEnvelope /> support@sasgroups.net
              </a>
              <a href="tel:+914045048332" className="flex items-center gap-2">
                <FaPhoneVolume /> +91-40-4504-8332
              </a>
            </div>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/share/12LTFCQo1Dh/" target="_blank" rel="noopener noreferrer" className="bg-black p-2 rounded-full hover:bg-gray-800">
                <FaFacebookF className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/swati_airport_support_services?igsh=MTZ2NW4zZ2lueWtsMA==" target="_blank" rel="noopener noreferrer" className="bg-black p-2 rounded-full hover:bg-gray-800">
                <FaInstagram className="w-4 h-4" />
              </a>
              <a href="https://youtu.be/vIPPaJEPK30?si=tYXDJZNZ5aoEj_pb" target="_blank" rel="noopener noreferrer" className="bg-black p-2 rounded-full hover:bg-gray-800">
                <FaYoutube className="w-4 h-4" />
              </a>
              <a href="https://www.linkedin.com/company/swatiairportsupport/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="bg-black p-2 rounded-full hover:bg-gray-800">
                <FaLinkedinIn className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Main Nav Bar */}
          <div className=" px-4 flex flex-col lg:flex-row items-center justify-between relative">
            {/* Logo and Toggle */}
            <div className="flex items-center justify-between w-full lg:w-auto ">
              <img src="/swati-logo.png" alt="Swati Logo" className="h-24 w-auto" />
              <div className="lg:hidden  text-3xl text-white cursor-pointer" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? <FaTimes /> : <FaBars />}
              </div>
            </div>

            {/* Nav Links */}
            <nav
              className={`flex flex-col lg:flex-row justify-center gap-4 text-lg lg:text-lg
    absolute lg:static w-full left-0 transition-all duration-300 ease-in-out
    z-40 px-6
    ${menuOpen ? 'top-24 opacity-100 visible py-6 bg-white' : 'top-[-999px] opacity-0 invisible py-0'}
    lg:top-auto lg:opacity-100 lg:visible lg:py-0 lg:bg-transparent
  `}
            >



              {[
                { path: "/", label: "Home" },
                { path: "/about", label: "About" },
                { path: "/services", label: "Services" },
                { path: "/products", label: "Products" },
                { path: "/career", label: "Career" },
                // { path: "/client-partners", label: "Client & Partners" },
                { path: "/contact", label: "Contact Us" },
                // { path: "/team", label: "Team & Events" },
              ].map(({ path, label }) => (
                <NavLink
                  key={path}
                  to={path}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center justify-between px-6 py-2 font-bold transition-all duration-300 text-center lg:text-left
                    ${isActive
                      ? "bg-orange-500 text-white border-b-2 border-orange-500 lg:bg-transparent lg:text-orange-600 lg:border-b-4 lg:border-orange-500"
                      : "text-black hover:bg-orange-400 hover:text-white border-b border-gray-700 lg:border-b-2 lg:border-transparent lg:hover:border-orange-400 lg:hover:text-orange-400 lg:hover:bg-transparent"}
                    ${!isActive ? "rounded-lg lg:rounded-none" : "rounded-lg lg:rounded-none"}`
                  }
                >
                  <span className="whitespace-nowrap">{label}</span>

                  <span className="block lg:hidden">
                    <FaArrowRight className="ml-2" />
                  </span>
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
